import { useFrame } from "@react-three/fiber";
import { useRef } from "react";
import { Center, Text3D } from "@react-three/drei";
import Rocket from "../meshes/Rocket";
import Ufo from "../meshes/Ufo";
import { animated } from "@react-spring/three";
import Star from "../meshes/Stars/Star";
import { useAtomValue, useAtom } from "jotai";
import { turnAtom, languageAtom } from "../GlobalState";
import { formatName, getNameFont } from "../logicHelpers/helpers";
import translations from '../dictionaries/translations';

export default function TurnAlert({position=[0,0,0], scale=1, rotation=[0,0,0], name=''}) {
  const turn = useAtomValue(turnAtom)
  const [language] = useAtom(languageAtom);
  const fontUrl = language === 'korean' ? "/fonts/Maplestory_Bold.json" : language === 'chinese' ? "/fonts/Xiao Xiangjiao font_Regular.json" : "/fonts/Luckiest Guy_Regular.json";

  const borderMesh0Ref = useRef();
  const borderMesh1Ref = useRef();
  const borderMesh2Ref = useRef();
  const borderMesh3Ref = useRef();
  const borderMesh4Ref = useRef();
  const borderMesh5Ref = useRef();
  const borderMesh6Ref = useRef();
  const borderMeshRefs = [
    borderMesh0Ref,
    borderMesh1Ref,
    borderMesh2Ref,
    borderMesh3Ref,
    borderMesh4Ref,
    borderMesh5Ref,
    borderMesh6Ref
  ]

  const width = 2.7
  const height = 2

  useFrame((state, delta) => {
    for (let i = 0; i < borderMeshRefs.length; i++) {      
      if (borderMeshRefs[i].current) {
        borderMeshRefs[i].current.position.x = Math.cos(state.clock.elapsedTime / 2 + 2 * Math.PI/borderMeshRefs.length * i) * width
        borderMeshRefs[i].current.position.y = 0.3
        borderMeshRefs[i].current.position.z = Math.sin(state.clock.elapsedTime / 2 + 2 * Math.PI/borderMeshRefs.length * i) * height
      }
    }
  })

  return <animated.group scale={scale} position={position} rotation={rotation}>
    <mesh
      castShadow
      receiveShadow
      scale={[2.6, 0.055, 2]}
    >
      <cylinderGeometry args={[1, 1, 1, 64]}/>
      <meshStandardMaterial color='black' opacity={0.8} transparent/>
    </mesh>
    <Center position={[0, 0.3, -0.2]} key={Math.random()}>
      <Text3D
        font={getNameFont(name, fontUrl)}
        rotation={[Math.PI/2, Math.PI, Math.PI]}
        size={0.6}
        height={0.01}
      >
        {formatName(name, 9)}
        <meshStandardMaterial color={ turn.team === 0 ? 'red': 'turquoise' }/>
      </Text3D>
    </Center>
    <Center position={[0, 0.3, 0.8]} key={Math.random()}>
      <Text3D
        font={fontUrl}
        rotation={[Math.PI/2, Math.PI, Math.PI]}
        size={0.4}
        height={0.01}
      >
        {translations.alerts.yourTurn[language]}
        <meshStandardMaterial color={ turn.team === 0 ? 'red': 'turquoise' }/>
      </Text3D>
    </Center>
    <group ref={borderMesh0Ref}>
      <Star position={[0, 0, 0]} rotation={[Math.PI/2, -Math.PI/2, Math.PI/2]} scale={0.3} color={ turn.team === 0 ? 'red': 'turquoise' }/>
    </group>
    <group ref={borderMesh1Ref}>
      { turn.team === 0 ? <Rocket 
      scale={0.4}
      /> : <Ufo
      scale={0.5}
      />}
    </group>
    <group ref={borderMesh2Ref}>
      { turn.team === 0 ? <Rocket 
      scale={0.4}
      /> : <Ufo
      scale={0.5}
      />}
    </group>
    <group ref={borderMesh3Ref}>
      { turn.team === 0 ? <Rocket 
      scale={0.4}
      /> : <Ufo
      scale={0.5}
      />}
    </group>
    <group ref={borderMesh4Ref}>
      { turn.team === 0 ? <Rocket 
      scale={0.4}
      /> : <Ufo
      scale={0.5}
      />}
    </group>
    <group ref={borderMesh5Ref}>
      { turn.team === 0 ? <Rocket 
      scale={0.4}
      /> : <Ufo
      scale={0.5}
      />}
    </group>
    <group ref={borderMesh6Ref}>
      { turn.team === 0 ? <Rocket 
      scale={0.4}
      /> : <Ufo
      scale={0.5}
      />}
    </group>
  </animated.group>
}